import {
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  Menu,
  MultiSelect,
  Paper,
  Select,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { useDebouncedState, useDisclosure, useHotkeys } from "@mantine/hooks";
import {
  IconBarcode,
  IconBrandBootstrap,
  IconBuildingWarehouse,
  IconCalendar,
  IconFileTypeCsv,
  IconReceipt,
  IconSearch,
  IconTags,
  IconUserPlus,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { repositoryPos } from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import {
  changeSearchValue,
  getValueById,
} from "../../../_base/helper/FunctionHelper";
import { BASE_API_POS } from "../../../config";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  getMasterOrgSelect,
  getTblDmEmployeeAll,
} from "../../../service/getSelectApi";
import { DatePickerInput } from "@mantine/dates";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const ManualPromotionProgramReport = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const navigate = useNavigate();
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [search, setSearch] = useState<any>({
    FromDate: _searchJson && checkedPinSearch ? _searchJson?.FromDate : "",
    ToDate: _searchJson && checkedPinSearch ? _searchJson?.ToDate : "",
    CreatedBy: _searchJson && checkedPinSearch ? _searchJson?.CreatedBy : "",
    MaBp: _searchJson && checkedPinSearch ? _searchJson?.MaBp : "",
    MaCn: _searchJson && checkedPinSearch ? _searchJson?.MaCn : [],
  });
  const [itemCode, setItemCode] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.itemCode : "",
    300,
  );
  const [maCtkm, setMaCtkm] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.maCtkm : "",
    300,
  );
  const [orderNumber, setOrderNumber] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.orderNumber : "",
    300,
  );
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300,
  );

  const [dataEmployee, setDataEmployee] = useState<any[]>([]);
  const [dataDepartment, setDataDepartment] = useState<any[]>([]);
  const [dataBranch, setDataBranch] = useState<any[]>([]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "orderNumber",
        header: "Mã đơn hàng",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue ? (
            <Tooltip label="Xem chi tiết">
              <Badge
                color="green"
                variant="dot"
                onDoubleClick={() => handleCheckView(row)}
                style={{ cursor: "pointer" }}
              >
                {renderedCellValue}
              </Badge>
            </Tooltip>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Badge variant="light">{renderedCellValue}</Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "quality",
        header: "Số lượng",
      },
      {
        accessorKey: "nguoiHuongDoanhSo",
        header: "Người hưởng số",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text fw={500} size="12.5px">
              {getValueById(String(renderedCellValue), dataEmployee, "label")}
            </Text>
          ) : (
            <></>
          ),
        size: 200,
      },
      {
        accessorKey: "createBy",
        header: "Người tạo đơn hàng",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text fw={500} size="12.5px">
              {getValueById(String(renderedCellValue), dataEmployee, "label")}
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "maCn",
        header: "Chi nhánh",
        Cell: ({ row }) => (
          <Text fw={500} size="12.5px">
            {[row.original.maCn, row.original.tenCn]
              ?.filter((i) => i && String(i).length > 0)
              ?.join(" - ")}
          </Text>
        ),
      },
      {
        accessorKey: "maBp",
        header: "Bộ phận",
        Cell: ({ row }) => (
          <Text fw={500} size="12.5px">
            {[row.original.maBp, row.original.tenBp]
              .filter((i) => i && String(i).length > 0)
              .join(" - ")}
          </Text>
        ),
      },
      {
        accessorKey: "maDtcn",
        header: "Đối tượng công nợ",
      },
      {
        accessorKey: "maCtkm",
        header: "Mã CTKM",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue ? (
            row.original.idCtkmKoTuNhap ? (
              <Tooltip label="Xem chi tiết">
                <Badge
                  color="green"
                  variant="dot"
                  onDoubleClick={() => {
                    navigate("/config-system/detail-promotion", {
                      state: { id: row.original.idCtkmKoTuNhap },
                    });
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {renderedCellValue}
                </Badge>
              </Tooltip>
            ) : (
              <Badge color="yellow" variant="dot">
                {renderedCellValue}
              </Badge>
            )
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "moTaCtkm",
        header: "Mô tả CTKM",
        size: 400,
        Cell: ({ renderedCellValue }) =>
          renderedCellValue && String(renderedCellValue).length < 68 ? (
            <Text fw={500} size="12.5px" w={400}>
              {renderedCellValue}
            </Text>
          ) : (
            <Menu width={600}>
              <Menu.Target>
                <Text fw={500} size="12.5px" truncate={"end"} w={400}>
                  {renderedCellValue}
                </Text>
              </Menu.Target>
              <Menu.Dropdown>
                <Paper shadow="md" p="xs">
                  <Box p={5}>
                    <Text fw={500} size="12.5px">
                      {renderedCellValue}
                    </Text>
                  </Box>
                </Paper>
              </Menu.Dropdown>
            </Menu>
          ),
      },
      {
        accessorKey: "priceOnPriceList",
        header: "Giá bán lẻ",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue || renderedCellValue === 0 ? (
            <Text fw={500} size="12.5px">
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "discountAmount",
        header: "Khuyến mãi",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue || renderedCellValue === 0 ? (
            <Text fw={500} size="12.5px">
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "voucherValue",
        header: "Khuyến mãi tổng đơn",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue ? (
            String(row.original.voucherType) === "1" ? (
              <Text fw={500} size="12.5px">
                {Number(renderedCellValue).toLocaleString()} VNĐ
              </Text>
            ) : String(row.original.voucherType) === "2" ? (
              <Text fw={500} size="12.5px">
                {renderedCellValue} %
              </Text>
            ) : (
              <Text fw={500} size="12.5px">
                {renderedCellValue}
              </Text>
            )
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "priceFinal",
        header: "Thành tiền",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue || renderedCellValue === 0 ? (
            <Text fw={500} size="12.5px">
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            <></>
          ),
      },
    ],
    [dataEmployee],
  );

  const handleCheckView = async (row: any) => {
    const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.orderNumber}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);
    if (response && response.success) {
      // Kiểm tra nếu orderNumber chứa "DT"
      if (row.original.orderNumber.includes("DT")) {
        navigate("/sell/view-order-return", {
          state: {
            orderNumber: row.original.orderNumber,
            actionType: "view",
          },
        });
      } else {
        navigate("/sell/view-order", {
          state: {
            orderNumber: row.original.orderNumber,
            actionType: "view",
          },
        });
      }
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/VBaoCaoCtkm/get-list?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (itemCode && itemCode.length > 0) {
        url += `&ItemCode=${itemCode?.trim()}`;
      }

      if (maCtkm && maCtkm.length > 0) {
        url += `&MaCtkm=${maCtkm?.trim()}`;
      }

      if (orderNumber && orderNumber.length > 0) {
        url += `&OrderNumber=${orderNumber?.trim()}`;
      }

      if (keySearch && keySearch.length > 0) {
        url += `&KeySearch=${keySearch?.trim()}`;
      }

      url += `&${params.toString()}`;

      const res = await repositoryPos.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        setData(result);
        setRowCount(res.totalCount);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          keySearch: keySearch,
        }),
      );
    }
  };

  const exportDataExcel = async () => {
    open();
    try {
      let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (itemCode && itemCode.length > 0) {
        url += `&ItemCode=${itemCode?.trim()}`;
      }

      if (maCtkm && maCtkm.length > 0) {
        url += `&MaCtkm=${maCtkm?.trim()}`;
      }

      if (orderNumber && orderNumber.length > 0) {
        url += `&OrderNumber=${orderNumber?.trim()}`;
      }

      if (keySearch && keySearch.length > 0) {
        url += `&KeySearch=${keySearch?.trim()}`;
      }

      url += `&${params.toString()}`;

      const baseUrl = `/api/v1/VBaoCaoCtkm/export-bao-cao-ctkm${url}`;

      const _url = BASE_API_POS + baseUrl;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "danh_sach_ctkm_tu_nhap.xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        NotificationExtension.Success("Export Excel thành công !");
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const fetchDataEmp = async () => {
    const res = await getTblDmEmployeeAll();

    if (res) {
      const data = res
        .filter((item) => item.id && item.fullname)
        .map((item) => ({
          label: `${item.code} - ${item.fullname}`,
          value: String(item.id),
        }));
      setDataEmployee(data);
    }
  };

  const fetchDataDepartment = async () => {
    const response = await repositoryPos.get(`/api/v1/TblDepartment/get-all`);
    if (response && response.success) {
      const result = response.data
        .filter(
          (item: any) =>
            item.deparmentCode !== null ||
            item.name !== null ||
            item.deparmentId !== null,
        )
        .map((item: any) => ({
          label: item.deparmentCode + " - " + item.name,
          value: item.deparmentCode?.toString(),
        }))
        .filter(
          (item: any, index: number, arr: any[]) =>
            arr.findIndex((x: any) => x.value === item.value) === index,
        );
      setDataDepartment(result);
    }
  };

  const getDataBranchSelect = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const data = res
        ?.filter((item) => item.text && item.value)
        ?.map((item) => ({
          label: `${item.att1} - ${item.text}`,
          value: String(item.att1),
        }));

      setDataBranch(data);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination?.pageIndex, pagination?.pageSize]);

  useEffect(() => {
    Promise.all([fetchDataEmp(), fetchDataDepartment(), getDataBranchSelect()]);
  }, []);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningManualPromotionProgramReport",
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
          left: ["mrt-row-select", "mrt-row-numbers"],
          right: ["action"],
        }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage(),
  );
  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningManualPromotionProgramReport",
      JSON.stringify(columnPinning),
    );
  }, [columnPinning]);

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (160 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: ["mrt-row-numbers", "maVt"],
        // right: ["action"],
        ...columnPinning,
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  useHotkeys([
    [
      "Enter",
      () => {
        fetchData();
      },
    ],
  ]);

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
          <Flex gap={"md"}>
            <Button
              leftSection={<IconFileTypeCsv size={16} />}
              onClick={() => exportDataExcel()}
            >
              Export Excel
            </Button>
          </Flex>
        </Flex>
        <Grid mt={10} w={"100%"}>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa tìm kiếm"
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              leftSection={<IconSearch color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              value={
                search.FromDate && search.FromDate?.length > 0
                  ? new Date(search.FromDate ?? "")
                  : null
              }
              maxDate={
                search.ToDate && search.ToDate?.length > 0
                  ? new Date(search.ToDate)
                  : new Date()
              }
              onChange={(e) => {
                changeSearchValue(
                  e
                    ? new Date(
                        new Date(e).getTime() + 7 * 3600 * 1000,
                      )?.toISOString()
                    : "",
                  "FromDate",
                  setSearch,
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              value={
                search.ToDate && search.ToDate?.length > 0
                  ? new Date(search.ToDate ?? "")
                  : null
              }
              minDate={
                search.FromDate && search.FromDate?.length > 0
                  ? new Date(search.FromDate)
                  : undefined
              }
              onChange={(e) => {
                changeSearchValue(
                  e
                    ? new Date(
                        new Date(e).getTime() + 7 * 3600 * 1000,
                      )?.toISOString()
                    : "",
                  "ToDate",
                  setSearch,
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Mã đơn hàng"
              defaultValue={orderNumber}
              onChange={(e) => setOrderNumber(e.currentTarget.value)}
              leftSection={<IconReceipt color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Mã sản phẩm"
              defaultValue={itemCode}
              onChange={(e) => setItemCode(e.currentTarget.value)}
              leftSection={<IconBarcode color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Mã CTKM"
              defaultValue={maCtkm}
              onChange={(e) => setMaCtkm(e.currentTarget.value)}
              leftSection={<IconTags color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Người tạo"
              leftSection={<IconUserPlus color="#15aabf" />}
              data={dataEmployee}
              value={search.CreatedBy}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) => {
                changeSearchValue(e ? e : "", "CreatedBy", setSearch);
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Chi nhánh"
              data={dataBranch}
              leftSection={<IconBrandBootstrap color="#15aabf" />}
              value={search.MaCn && search.MaCn?.length > 0 ? search.MaCn : []}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) => changeSearchValue(e ? e : [], "MaCn", setSearch)}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Bộ phận"
              leftSection={<IconBuildingWarehouse size={20} color="#15aabf" />}
              data={dataDepartment}
              value={search.MaBp}
              searchable
              clearable
              onChange={(e) => {
                changeSearchValue(e ? e : "", "MaBp", setSearch);
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Button
              onClick={() => fetchData()}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default ManualPromotionProgramReport;
